import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import About from "../component/section/about";
import Achievement from "../component/section/achievement";
import Banner from "../component/section/banner";
import Blog from "../component/section/blog";
import Category from "../component/section/category";
import Course from "../component/section/course";
import Instructor from "../component/section/instructor";
import Sponsor from "../component/section/sponsor";
import Student from "../component/section/student";
import HeaderWhite from "../component/layout/headerwhite";
import { Link } from "react-router-dom";

import SearchPage from "./search-page";


const Home = () => {
    return (
        <Fragment>
            {/* <Header /> */}
            <HeaderWhite/>
            

            <Banner />
           {/*ro*/}
              <div className="reg-sections-container">
               {/* Section 1: Want to be a Tutor? */}
               <section className="reg-card tutorr-card tutor ">
                   <div className="card-content">
                       <h3>Want to be a Tutor</h3>
                       <p>
                           Share your expertise and teach students across various art forms.
                       </p>
            
                       {/* Link to the Tutor Signup Page */}
                       <Link to="/tutor/signup" className="action-btn tutor-signup-btn">
                           Sign Up 
                       </Link>
                   </div>
               </section>
           
               {/* Section 2: Join as a Student */}
               <section className="reg-card student-card student ">
                   <div className="card-content">
                       <h3>Join as a Student</h3>
                        <p>
                           Explore top tutors in Singing, Dance, Art, and more.
                       </p> 
           
                       {/* Link to the Student Signup Page */}
                       <Link to="/signup" className="action-btn student-signup-btn">
                           Sign Up 
                       </Link>
                   </div>
               </section>
           </div>
            {/* <section className="become-tutor-section">
    <div className="tutor-box">
        <h2>Want to be a Tutor?</h2>
        <p>
            Share your talent in Singing, Dance, Painting, Crafts and more.  
            Join Kalakakshaaha as a tutor and inspire students!
        </p>

        <Link to="/tutor/signup" className="tutor-btn" style={{color:"white"}}>
            Sign Up as Tutor
        </Link>
    </div>
</section> */}
            {/* <Sponsor /> */}
            <Category />
            {/* <Course /> */}
            <About />
            <Instructor />
            {/* <Student /> */}
            <Blog />
            {/* <Achievement /> */}
            
            <Footer />
        </Fragment>
    );
}
 
export default Home;